/// <amd-module name="Search/Code/Flux/Sources/CodeSearchSource" />

import * as Rest_Client from "Search/LegacyWebApi/RestClient/Search";
import * as Contracts from "Search/LegacyWebApi/Contracts/Code";
import * as SearchShared from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { IVssPageContext } from "VSS/Platform/Context";
import { SearchSourceType, ISearchSourceResponse } from "Search/Shared/Base/Sources/SearchSource";
import { IProjectData } from "Tfs/Platform/Page";
import { SearchSourceBase } from "Search/Shared/Base/Sources/SearchSource";
import { CustomerIntelligenceConstants } from "Search/Code/Constants";
import { IVssPageService, IPageData } from "VSS/Platform/Page";

const WHITESPACE_REGEX = /\s+/;
const WILDCARD_REGEX = /[\*\?]+/;
const SPECIALCHAR_REGEX = /[^A-Za-z0-9_\?\*()\[\]:]/;

export class CodeSearchSource extends SearchSourceBase<Contracts.SearchQuery> {
    private codeSearchRestClient: Rest_Client.ISearchRestClient;
    private pageData: IPageData | undefined;

    constructor(
        private readonly pageContext: IVssPageContext,
        private readonly project: IProjectData | undefined) {
        super(CustomerIntelligenceConstants.QueryResultScenarioName, CustomerIntelligenceConstants.EntityName, pageContext);
        this.codeSearchRestClient = this.pageContext.getRestClient<Rest_Client.ISearchRestClient>("Legacy.ISearchRestClient");
        this.pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData();
    }

    public getResults(
        request: Contracts.SearchQuery,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error, activityId }: any) => void): void {
        if (this.isAdvancedCodeQuery(request.searchText)) {
            this.codeSearchRestClient
                .postAdvancedCodeQuery(request, this.project && this.project.id)
                .then(responseWithActivityId => {
                    onSuccess({ responseWithActivityId, source: SearchSourceType.RestApi });
                }, error => {
                    onFailure({ error, activityId: this.pageData && this.pageData.sessionId });
                });

        } else {
            this.codeSearchRestClient
                .postCodeQuery(request, this.project && this.project.id)
                .then(responseWithActivityId => {
                    onSuccess({ responseWithActivityId, source: SearchSourceType.RestApi });
                }, error => {
                    onFailure({ error, activityId: this.pageData && this.pageData.sessionId });
                });
        }
    }

    public getFacets(
        searchQuery: Contracts.SearchQuery,
        onSuccess: (responseWithActivityId: SearchShared.EntitySearchResponseWithActivityId) => void,
        onFailure: () => void): void {
        // Invoking advanced query always.
        this.codeSearchRestClient
            .postAdvancedCodeQuery(searchQuery, this.project && this.project.id)
            .then(responseWithActivityId => {
                onSuccess(responseWithActivityId);
            }, error => {
                onFailure();
            });
    }

    /**
     * Duplicating the routine from QueryHelper.cs to determine the type of code query request.
     * @param queryText
     */
    private isAdvancedCodeQuery(queryText: string): boolean {
        let isAdvanceQuery = false;
        if (!!queryText && queryText !== "") {
            if (WILDCARD_REGEX.test(queryText)) {
                isAdvanceQuery = true;
            } else {
                // Query is considered advance if it has more than 2 terms or it is unscoped(no filters applied)
                // or there is atleast one term with special characters other than (, ), [, ], :
                const terms: string[] = queryText.split(WHITESPACE_REGEX).filter(s => s !== "" && !!s);
                const termsCount = terms.length;
                if (termsCount > 2 ||
                    (termsCount === 2 && queryText.indexOf(":") < 0) ||
                    terms.filter(s => SPECIALCHAR_REGEX.test(s)).length > 0) {
                    isAdvanceQuery = true;
                }
            }
        }

        return isAdvanceQuery;
    }
}
